/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { LANGUAGES, REGIONS } from './types';

export enum PROD_SUPPORTED_LANGUAGES {
  en = LANGUAGES.en,
  fr = LANGUAGES.fr,
}

export const PROD_DEFAULT_LANGUAGE = {
  [REGIONS.CA]: PROD_SUPPORTED_LANGUAGES.en,
  [REGIONS.US]: PROD_SUPPORTED_LANGUAGES.en,
};
